export function getAssetByName(assetName, assets, elementData) {
    if (elementData) {
        return Object.values(elementData?.part_version_data_cache?.assets ?? {}).find((asset) => asset.name === assetName);
    }
    else if (assets) {
        return Object.values(assets).find((asset) => asset.name === assetName);
    }
    return undefined;
}
//# sourceMappingURL=getAssetByName.js.map